import React, { Component } from "react";
import Layout from "../Layout";

import { Button, Input, Textarea, Select, AutoCompleteTextBox } from "~/js/partials";
import { isInitialValid, groupDealerships, getLocations, formatGroupLabel, processMakes,processModels } from "~/js/utils";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { formsService } from "~/js/_services";
import { favouritesService } from "~/js/_services";
import Turnstile from "react-turnstile";
import {addEmailPhoneDatalayer, normalizeMake} from "../../../utils";
import {Checkbox} from "../../../partials";

const vehicle = window.current_vehicle ?? null;
const dealer = window.current_dealer ?? null;
const is_dealer = window.is_dealer_page;
// Regions & dealership data for form population
let dealershipsGrouped = [];
let locations = [];
const makesData = processMakes(window.makes_data);
let modelData = [];

class FormMakeTradeEnquiry extends Component {
  state = {
    dealership: null,
    dealerships: dealershipsGrouped,
    locationDealerships: null,
    currentMake: null,
    refinedDealership: null,
    lastDealership: null,
    make : "",
    turnstileToken : "",
  };

  enableTurnstile = true;

  constructor(props) {
    super(props);
    dealershipsGrouped = groupDealerships(props.regions);
    locations = getLocations(props.regions);
    this.setState({dealerships: dealershipsGrouped})
  }
  componentDidMount() {
    this.favouritesSubscription = favouritesService.current.subscribe((f) => {
      this.setState({
        favourites: f,
      });
    });

   modelData = processModels(this.props.models);

    if(dealer){
        this.state.dealerships.forEach(group => {
            if(group.options){
                group.options.forEach(dealership => {
                    if(dealer['ID'] == dealership['dealer']['ID']){
                        // this.defaultDealer = dealershipsGrouped[1]['options'][0];
                        // console.log(this.defaultDealer);
                        this.setState({ formDealerID: dealer['ID'] });
                        this.setState({dealership: dealer});

                    }

                });
            }
        });
    }
  }

  /**
   * Sorts and processes a list of dealerships, updating the component's state
   * with the next dealership or cycling back to the first one if at the end
   * of the list. It also updates the `refinedDealership` and `lastDealership`
   * properties in the state for further use.
   *
   * @function
   * @name sortDealerships
   * @param {Array<Object>} dealerships - Array of dealership objects. Each
   * dealership object is expected to have an `id` property which is used for
   * comparison and state updates.
   */
  sortDealerships = (dealerships) => {
    const firstDealership = dealerships[0];
    if (this.state.lastDealership){
      const current = dealerships.findIndex((dealership) => dealership.id === this.state.lastDealership)
      const next = dealerships[current + 1];
      if(next){
        this.setState({refinedDealership: next}, () => {
          this.setState({lastDealership: next.id});
          console.log(this.state.lastDealership)
        });
      } else {
        this.setState({lastDealership: firstDealership.id}, () => {
          console.log(this.state.lastDealership)
        });
      }
    } else {
      this.setState({refinedDealership: firstDealership}, () => {
        this.setState({lastDealership: firstDealership.id}, () => {
          console.log(this.state.lastDealership)
        });
      });
    }
    console.log(this.state.refinedDealership)
  }

  /**
   * Filters and updates the state to include dealerships based on the provided location.
   *
   * @function
   * @param {Object} location - The location object containing dealership data.
   * @param {Array} location.dealerships - An array of dealerships available in the location.
   *
   * @description
   * If the provided location object contains dealerships, this function updates the state
   * with `locationDealerships` derived from `location.dealerships`. After updating the state,
   * it logs the location and its dealerships to the console.
   *
   * Additionally, if a `currentMake` is present in the component's state, it calls
   * the `refineDealershipByMake` function to further refine the dealerships by the
   * current make.
   */
  refineDealershipByLocation = (location) => {
    if (location.dealerships) {
      this.setState({locationDealerships: location.dealerships}, () => {
        console.log("There are locations", location, location.dealerships )
        if (this.state.currentMake){
          this.refineDealershipByMake(this.state.currentMake);
        }
      });
    }
  }

  /**
   * Filters and refines the list of dealerships based on the specified car make.
   *
   * This method sets the `currentMake` state to the provided make and filters the
   * `locationDealerships` state for dealerships whose `label` includes the make string.
   * Depending on the number of matches, it either refines the dealerships to a single match
   * or sorts the list of dealerships for further processing. If no matches are found, it resets
   * the refined dealership and performs sorting on all available location dealerships.
   *
   * @param {string} make - The car make used to filter and refine the dealership list.
   */
  refineDealershipByMake = (make) => {
    this.setState({currentMake: make})
    if(this.state.locationDealerships){
      let foundDealerships = this.state.locationDealerships.filter((dealership) => dealership.label.includes(make.toLowerCase()))
      if (foundDealerships.length > 0){
        if(foundDealerships.length === 1){
          this.setState({refinedDealership: foundDealerships[0]}, () => {
            console.log("Found!", this.state.refinedDealership )
          });
        } else {
          console.log("Multiple 'Make' dealerships, loop through them")
          this.sortDealerships(foundDealerships);
        }
      } else {
        this.setState({refinedDealership: null}, () => {
          console.log("No 'Make' dealership, loop through location dealerships ")
          this.sortDealerships(this.state.locationDealerships);
        });
      }
    }
  }

  defaultDealerGet = () => {
      let defaultDealer;
      if(dealer){
          dealershipsGrouped.forEach(group => {
              if(group.options){
                  group.options.forEach(dealership => {
                      if(dealer['ID'] == dealership['dealer']['ID']){
                          defaultDealer = dealership;
                      }

                  });
              }
          });
      }
      return defaultDealer;

  }

  componentWillUnmount() {
    this.favouritesSubscription.unsubscribe();
  }

  componentDidUpdate(prevProps) {
    if (this.props.type !== prevProps.type) {
      if (this.formik) this.formik.resetForm();
    }
  }

  findYard = () => {
      return vehicle['@BODY_YARD_SEQ'];
  }
  get isVehicle() {
    return window.is_vehicle_page;
  }

  get isFavourites() {
    return this.props.type === "make-an-enquiry-favourites";
  }

  handleSubmit = (fields, { setStatus, setSubmitting }) => {
    const { showSuccessPopup, type } = this.props;

    // Reset status, if there where errors
    setStatus();
      let turnstileData = {
          response: this.state.turnstileToken,
      }

      const turnstilePromise = this.enableTurnstile
        ? formsService.turnstileVerification(turnstileData)
        : Promise.resolve({ data: { success: true } });

      //check Turnstile Backend Verification
      turnstilePromise.then((response) => {
          if(response.data.success){
    let data = {
      name: "Trade In Appraisal",
      fields: JSON.parse(JSON.stringify(fields)),
    };
    if(dealer){
      data.fields.formDealerID = window.current_dealer["ID"];
    } else {
      data.fields.formDealerID = this.state.refinedDealership?.id;
    }

    if (this.isVehicle) {
      data.vehicle = vehicle
        ? `${vehicle["@LISTING_SEQ"]} (${vehicle["@LISTING_TITLE"]})`
        : null;
      data.dealer = dealer
        ? `${dealer.data.autoplay.dealer} (${dealer.post_title})`
        : null;
      data.fields.formVehicleRegistration = vehicle ? vehicle['@LISTING_STOCK_NO'] : null;
      data.fields.vehicleYardId = vehicle['@BODY_YARD_SEQ'];
      data.fields.formDealerID = window.current_dealer["ID"];
        let foundYard = this.findYard();
        if(foundYard){
            data.fields.yard = foundYard;
        }
        data.fields.new = vehicle['@LISTING_NEW'];

    }

    if (window.offerTitle) {
      data.fields.offerTitle = window.offerTitle;
    }

      if(window.current_brand){
          data.backupBrand = window.current_brand;
      }

    if (this.isFavourites) {
      data.favourites = ``;
      for (var key in this.state.favourites) {
        data.favourites += `${this.state.favourites[key].id} `;
      }
    }

    if (window.is_careers) {
      data.name = "Careers Page General Enquiry";
    }

    if (this.state.formDealerID) {
      data.fields.formDealerID = this.state.formDealerID;
      if(this.state.dealership){
          data.fields.dealer = this.state.dealership["post_title"];
      }
    }

    formsService.makeTradeEnquiry(data).then(
      (success) => {
        const title = "Your submission is successful";
        const text = "We will contact you about your valuation soon.";
        showSuccessPopup({ title, text });
        setSubmitting(false);

        let formType = this.props.type;

        if (this.isVehicle) {
          formType = `make-an-enquiry-${vehicle["@LISTING_SEQ"]}`;
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "FormSubmit",
          formType: formType,
          formBrand: vehicle ? vehicle["@LISTING_MAKE"] : null,
          formModel: vehicle ? vehicle["@LISTING_MODEL"] : null,
          formRegion: null,
          formDealership: data.dealer ? data.dealer : null,
          formKm0: vehicle ? vehicle["@LISTING_ODOMETER"] : null,
          formVehicleRegistration: vehicle
            ? vehicle["@LISTING_STOCK_NO"]
            : null,
            'phone': data.fields.phone,
            'email': data.fields.email
        });
      },
      (error) => {
        setSubmitting(false);
        setStatus(error.message);
      }
    );
          }else{
              setSubmitting(false);
              setStatus("Error with Turnstile Verification");
          }
      });
  };

  renderForm = (props) => {
    const { isValid, isSubmitting, status } = props;

    let extraClass = "form-make-an-enquiry";

    if (this.isFavourites) {
      extraClass = `form-make-an-enquiry-favourites`;
    }

    const testValue = dealershipsGrouped[1]['options'][3];

    if (this.isVehicle) {
      extraClass = `form-make-an-enquiry-${vehicle["@LISTING_SEQ"]}`;
    }

    return (
      <Form className="popup-form__form">
        <div className="popup-form__group">
          <div className="popup-form__label">Personal details</div>

          <div className="popup-form__row">
            <div className="popup-form__col">
              <Input
                name={`firstName`}
                placeholder={`First Name`}
                modifiers={["form"]}
                form={props}
              />
            </div>
            <div className="popup-form__col">
              <Input
                name={`lastName`}
                placeholder={`Last Name`}
                modifiers={["form"]}
                form={props}
              />
            </div>
          </div>

          <div className="popup-form__row">
            <div className="popup-form__col">
              <Input
                name={`phone`}
                placeholder={`Phone`}
                modifiers={["form"]}
                form={props}
                type="tel"
              />
            </div>
          </div>

          <div className="popup-form__row">
            <div className="popup-form__col">
              <Input
                name={`email`}
                placeholder={`Email (optional)`}
                modifiers={["form"]}
                form={props}
                type="email"
              />
            </div>
          </div>
        </div>
          {!(is_dealer || vehicle) ? (
              <div className="popup-form__group">
              <div className="popup-form__label">Location</div>
              <div className="popup-form__row">
                  <div className="popup-form__col">
                      <Select
                          name={`location`}
                          form={props}
                          options={locations}
                          onChange={(location) => {
                              this.refineDealershipByLocation(location)
                          }}
                          modifiers={['form']}
                      />
                  </div>
              </div>
          </div>
              )
          : null}

        <div className="popup-form__group">
          <div className="popup-form__label">Vehicle details</div>
          <div className="popup-form__row">
            <div className="popup-form__col">
                <AutoCompleteTextBox
                    name={`make`}
                    form={props}
                    placeholder={'Make'}
                    modifiers={["form"]}
                    options={makesData}
                    form={props}
                    onChange={(make) => {
                        const checkMake = normalizeMake(make);
                        this.refineDealershipByMake(checkMake)

                    }}
                />
            </div>
            <div className="popup-form__col">
                <AutoCompleteTextBox
                    name={`model`}
                    form={props}
                    placeholder={'Model'}
                    modifiers={["form"]}
                    options={modelData}
                    form={props}
                />
            </div>
          </div>

          <div className="popup-form__row">
            <div className="popup-form__col">
              <Input
                name={`rego`}
                placeholder={`Registration / License Plate`}
                modifiers={["form"]}
                form={props}
              />
            </div>
              <div className="popup-form__col">
                  <Input
                      name={`vehicleYear`}
                      placeholder={`Vehicle Year`}
                      modifiers={["form"]}
                      form={props}
                  />
              </div>
          </div>
            <div className="popup-form__row">
                <div className="popup-form__col">
                    <Checkbox
                        label={{ text: 'NZ New'}}
                        name={`nzNew`}
                        form={props}
                    />
                </div>
                <div className="popup-form__col">
                    <Input
                        modifiers={["form"]}
                        name={`mileage`}
                        placeholder={`Mileage`}
                        form={props}
                    />
                </div>
            </div>
        </div>

        <div className="popup-form__group pb-3">
          <div className="popup-form__label">Your message</div>

          <div className="popup-form__row">
            <div className="popup-form__col">
              <Textarea
                name={`message`}
                placeholder={`Add your message`}
                form={props}
              />
            </div>
          </div>
        </div>

        {status && <div className={"popup-form__alert pb-3"}>{status}</div>}
        {this.enableTurnstile &&
          <Turnstile
              sitekey={process.env.TURNSTILE_SITE_KEY}
              onVerify={(token) => {
                  this.setState({turnstileToken : token});
              }}
              theme={'light'}
          />
        }
        <div className="popup-form__submit">
          <Button
            extraClass={extraClass}
            title={`Submit details`}
            modifiers={["solid", "medium"]}
            chevron={true}
            type="submit"
            disabled={this.enableTurnstile && (!isValid || !this.state.turnstileToken)}
            loading={isSubmitting}
          />
        </div>
      </Form>
    );
  };

  render() {
    const { ...rest } = this.props;
    const title = `Arrange a valuation`;
    const text = `Fill in your details below and we’ll get back to you `;

    const initialValues = {
        firstName: "",
        lastName: "",
        message: "",
        email: "",
        vehicleYear: "",
        phone: "",
        nzNew: false,
        zapierUrl: window.location.href,

    };

    const validationSchema = Yup.object().shape({
        firstName: Yup.string().required("Required"),
        lastName: Yup.string().required("Required"),
        message: Yup.string().required("Required"),
        email: Yup.string().email("Invalid email"),
        phone: Yup.string().required("Required"),
        make: Yup.string().required("Required"),
        model: Yup.string().required("Required"),
        mileage: Yup.string(),
        nzNew: Yup.bool(),
        vehicleYear: Yup.string().required("Required"),
        // dealership: (!dealer) ? Yup.string().required('Required') : Yup.string(),
        dealership: Yup.string(),
        location: (!dealer) ? Yup.string().required('Required') : Yup.string(),
        rego: Yup.string().required("Required"),
    });

    const other = {};

    if (this.isVehicle) {
      other.vehicle = vehicle;
      other.dealer = dealer;
    }

    return (
      <Layout title={title} text={text} {...rest} {...other}>
        <Formik
          isInitialValid={isInitialValid}
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={this.handleSubmit}
          children={this.renderForm}
        />
      </Layout>
    );
  }
}

export default FormMakeTradeEnquiry;
